export default "__VITE_ASSET__ca6dfed8__"